module.exports = __webpack_public_path__ + "static/media/191CS138.09dc7565.jpeg";